<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar
      tile
      height="60"
      width="60"
    >
      <v-img
        :src="
          require(teal ? '@/assets/infinity-teal.png' : '@/assets/infinity.png')"
      />
    </v-list-item-avatar>

    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h3">
        <v-img
          :src="
            require(teal ? '@/assets/infinity-text-teal.png' : '@/assets/infinity-text.png')"
        />
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'
  import { mapState } from 'pinia'
  import { useInterfaceStore } from '@/store/interface-store'

  export default {
    name: 'DefaultDrawerHeader',

    computed: { 
      ...mapState(useInterfaceStore, ['teal']),
      version: get('app/version'),
    },
  }
</script>
